class Job {
  static get STATUS_CREATED() {
    return 1;
  }

  static get STATUS_PENDING() {
    return 2;
  }

  static get STATUS_ACCEPTED() {
    return 3;
  }

  static get STATUS_PICKUP_ARRIVING() {
    return 4;
  }

  static get STATUS_PICKUP_ARRIVED() {
    return 5;
  }

  static get STATUS_PICKUP_ESTIMATE() {
    return 6;
  }

  static get STATUS_ESTIMATED() {
    return 7;
  }

  static get STATUS_APPROVED() {
    return 8;
  }

  static get STATUS_PICKUP_LOADING() {
    return 9;
  }

  static get STATUS_PICKUP_LOADED() {
    return 10;
  }

  static get STATUS_DELIVERY_ARRIVING() {
    return 11;
  }

  static get STATUS_DELIVERY_ARRIVED() {
    return 12;
  }

  static get STATUS_DELIVERY_ESTIMATE() {
    return 13;
  }

  static get STATUS_DELIVERY_UNLOADING() {
    return 14;
  }

  static get STATUS_DELIVERY_UNLOADED() {
    return 15;
  }

  static get STATUS_COMPLETED() {
    return 16;
  }

  static get STATUS_PAUSED() {
    return 20;
  }

  static get STATUS_ON_HOLD() {
    return 21;
  }

  static get STATUS_CANCELED() {
    return 30;
  }

  static get STATUS_REJECTED() {
    return 31;
  }

  static get STATUS_IN_PROGRESS() {
    return 40;
  }

  static get STATUS_TOTAL_TIME() {
    return 41;
  }

  static get STATUS_PAYMENT() {
    return 42;
  }

  static get STATUS_EXPENSES_AND_DISCOUNTS() {
    return 43;
  }

  static get STATUS_FOREMAN_SIGNATURE() {
    return 44;
  }

  static get STATUS_CUSTOMER_SIGNATURE() {
    return 45;
  }

  static get STATUS_DRIVING_TO_JOB() {
    return 46;
  }

  static get STATUS_DRIVING_FROM_JOB() {
    return 47;
  }

  static get STATUS_PRE_BOOKING() {
    return 50;
  }

  static get IN_PROGRESS_STATUSES() {
    return [
      this.STATUS_CUSTOMER_SIGNATURE,
      this.STATUS_DELIVERY_ARRIVED,
      this.STATUS_DELIVERY_ARRIVING,
      this.STATUS_DELIVERY_ESTIMATE,
      this.STATUS_DELIVERY_UNLOADED,
      this.STATUS_DELIVERY_UNLOADING,
      this.STATUS_DRIVING_FROM_JOB,
      this.STATUS_DRIVING_TO_JOB,
      this.STATUS_EXPENSES_AND_DISCOUNTS,
      this.STATUS_FOREMAN_SIGNATURE,
      this.STATUS_IN_PROGRESS,
      this.STATUS_PAUSED,
      this.STATUS_PAYMENT,
      this.STATUS_PICKUP_ARRIVED,
      this.STATUS_PICKUP_ARRIVING,
      this.STATUS_PICKUP_ESTIMATE,
      this.STATUS_PICKUP_LOADED,
      this.STATUS_PICKUP_LOADING,
      this.STATUS_TOTAL_TIME,
    ];
  }

  static get BEFORE_IN_PROGRESS() {
    return [
      this.STATUS_CREATED,
      this.STATUS_PENDING,
      this.STATUS_ACCEPTED,
      this.STATUS_ON_HOLD,
      this.STATUS_REJECTED,
    ];
  }

  static isJobInProgress(statusId) {
    return this.IN_PROGRESS_STATUSES.includes(statusId);
  }

  static isBeforeJobInProgress(statusId) {
    return this.BEFORE_IN_PROGRESS.includes(statusId);
  }

  static statusName(id) {
    const statusMapper = {
      1: 'Created',
      2: 'Pending',
      3: 'Accepted',
      4: 'Pickup arriving',
      5: 'Pickup arrived',
      6: 'Pickup estimate',
      7: 'Estimated',
      8: 'Approved',
      9: 'Pickup loading',
      10: 'Pickup loaded',
      11: 'Delivery arriving',
      12: 'Delivery arrived',
      13: 'Delivery estimate',
      14: 'Delivery unloading',
      15: 'Delivery unloaded',
      16: 'Completed',
      20: 'Paused',
      21: 'On Hold',
      30: 'Canceled',
      31: 'Rejected',
      40: 'In Progress',
      41: 'Time tracking finished',
      42: 'Payment',
      43: 'Job finals',
      44: 'Foreman signature',
      45: 'Customer signature',
      46: 'Driving to job',
      47: 'Driving from job',
    };

    return statusMapper[id];
  }
}

export default Job;



// WEBPACK FOOTER //
// ./src/classes/Job.js